<template>
  <div class="user-main">
    <div class="user-info">
      <span>{{ setPeriod() }}: {{ userInfo?.nickName || '' }}</span>
    </div>
    <div class="nav_top_tool">
      <div
        class="tool_item"
        v-for="(item, index) in toolList"
        :key="index"
        @click="handleTool(item)"
      >
        <div class="tool_icon">
          <img :src="item.icon" alt="工具图标" />
          <span v-if="item.badge" class="badge-dot"></span>
        </div>
        <span class="tool-name">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { setPeriod } from '@/util/utils';
import { closeWebSocket } from '@/util/webSokt';
import { removeStore } from '@/util/store';
import { logout } from '@/api/login';
export default {
  components: {},
  props: {},
  data() {
    return {
      setPeriod,
      updatePeriod: null,
      user: '管理员',
      toolList: [
        {
          icon: require('@/assets/images/icon/help_icon.png'),
          name: '帮助',
          code: 'help',
        },
        {
          icon: require('@/assets/images/icon/service_icon.png'),
          name: '客服',
          code: 'service',
        },
        {
          icon: require('@/assets/images/icon/safe_icon.png'),
          name: '安全',
          code: 'safe',
        },
        {
          icon: require('@/assets/images/icon/logout_icon.png'),
          name: '退出',
          code: 'logoutSystem',
        },
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  created() {
    setPeriod();
  },
  mounted() {
    this.updatePeriod = setInterval(() => {
      setPeriod();
    }, 600000);
  },
  destroyed() {
    clearInterval(this.updatePeriod);
  },
  methods: {
    handleTool(item) {
      this[item.code] && this[item.code]();
    },

    home() {
      this.$router.push('/pages/home');
    },
    help() {
      this.$router.push('/help');
    },
    service() {
      window.open(
        'https://tccc.qcloud.com/web/im/chat/?webAppId=de4c1a1043e99aaa0a43e8206fbc0a22'
      );
    },
    wait() {
      // this.$store.commit('toDoMsg', '');
      // removeStore({ name: 'toDoMsg' });
      // this.$router.push('/toDo');
    },
    safe() {
      this.$router.push('/pages/safety');
    },

    //退出
    async logoutSystem() {
      const flag = await this.$asyncConfirm('确定退出此系统吗?');
      if (flag == 'confirm') {
        let { code, data } = await logout();
        if (code == 200) {
          this.$store.commit('toDoMsg', '');
          // 清除localStorage中的所有项
          localStorage.clear();
          // 清除sessionStorage中的所有项
          sessionStorage.clear();
          this.$router.push('/');
          closeWebSocket();
        }
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.user-main {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  color: #ffffff;

  .user-info {
    font-size: 15px;
    padding-right: 15px;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    margin-right: 15px;
    white-space: nowrap;
  }

  .nav_top_tool {
    display: flex;
    align-items: center;

    .tool_item {
      display: flex;
      align-items: center;
      margin-left: 18px;
      cursor: pointer;
      // padding: 5px 8px;
      border-radius: 4px;
      transition: all 0.2s ease;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        transform: translateY(-2px);
      }

      .tool_icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        padding: 3px;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        margin-right: 6px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .badge-dot {
          position: absolute;
          top: -2px;
          right: -2px;
          width: 10px;
          height: 10px;
          background-color: #ff4d4f;
          border-radius: 50%;
          border: 2px solid #165dff;
        }
      }

      .tool-name {
        font-size: 14px;
        transition: all 0.2s ease;
      }

      // 退出按钮特殊样式
      &:last-child {
        .tool_icon {
          background-color: rgba(255, 77, 79, 0.1);
          border: 1px solid rgba(255, 77, 79, 0.3);

          img {
            filter: brightness(0) invert(1) sepia(1) saturate(10) hue-rotate(340deg);
          }
        }

        .tool-name {
          color: #ff4d4f;
        }

        &:hover {
          background-color: rgba(255, 77, 79, 0.1);
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .user-main {
    .user-info {
      font-size: 14px;
      padding-right: 10px;
      margin-right: 10px;
    }

    .tool_item {
      margin-left: 12px !important;

      .tool-name {
        display: none;
      }

      .tool_icon {
        margin-right: 0 !important;
      }
    }
  }
}

@media (max-width: 480px) {
  .user-main {
    .user-info {
      display: none;
    }
  }
}
</style>
